export const COMPANIES_SET_LOADING = 'COMPANIES/SET_LOADING';
export const COMPANIES_SET_ERROR = 'COMPANIES/SET_ERROR';
export const COMPANIES_SET_COMPANIES = 'COMPANIES/SET_COMPANIES';
export const COMPANIES_SET_PAGINATION = 'COMPANIES/SET_PAGINATION';

export const COMPANIES_FETCH_COMPANIES = 'COMPANIES/FETCH_COMPANIES';
export const COMPANIES_RESEND_WELCOME_KIT = 'COMPANIES/RESEND_WELCOME_KIT';
export const COMPANIES_CLEAR_ERROR = 'COMPANIES/CLEAR_ERROR';

export const COMPANIES_GET_COMPANIES = 'COMPANIES/GET_COMPANIES';
export const COMPANIES_GET_PAGINATION = 'COMPANIES/GET_PAGINATION';
export const COMPANIES_GET_LOADING = 'COMPANIES/GET_LOADING';
export const COMPANIES_GET_ERROR = 'COMPANIES/GET_ERROR';
